<template>
  <div>
    <v-card :loading="loading" elevation="0" class="rounded-xl">
      <div class="pa-3">
        <div class="d-flex justify-space-between align-center mb-3">
          <h6 class="mb-0">Eventos</h6>
          <v-switch
            v-if="data?.user?.TicketOwner?.length"
            v-model="showCancelled"
            label="Mostrar ingressos cancelados"
            hide-details
            dense
            class="ma-0 pa-0"
          />
        </div>
        <p v-if="data?.user?.TicketOwner?.length === 0" class="tex-center mb-0">
          Cliente ainda não possui ingressos.
        </p>
        <div v-else class="d-flex flex-column gap-4 px-1 pb-1">
          <v-text-field
            v-if="ticketsGroupedByParty.length > 3"
            v-model="search"
            label="Procurar evento"
            hide-details
            dense
            outlined
            class="ma-0 pa-0"
          />
          <v-card
            v-for="party in filteredEvents"
            :key="party.id"
            class="pa-3"
            outlined
            rounded="lg"
          >
            <!-- {{ party }} -->
            <div class="d-flex gap-3 flex-wrap">
              <div>
                <v-img
                  :src="party.cover"
                  :aspect-ratio="16 / 9"
                  class="rounded-lg"
                  height="60px"
                  :width="60 * (16 / 9)"
                />
              </div>
              <div class="d-flex flex-grow-1">
                <div class="flex-grow-1">
                  <small class="text-overline lh-1">
                    {{ party.Organization.name }} •
                    {{ party.Organization.Platform.name }}
                  </small>
                  <h6 class="lh-1 mb-0">{{ party.name }}</h6>
                  <span>
                    {{ party.date | date }}
                  </span>
                </div>
                <div>
                  <v-btn small icon @click="openParty(party)">
                    <v-icon>mdi-information</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>

            <p class="mb-0 font-weight-bold mt-1">
              {{ party.ticketsOwned.length }} Ingresso{{
                party.ticketsOwned.length > 1 ? "s" : ""
              }}
            </p>
            <v-expansion-panels focusable accordion>
              <v-expansion-panel
                v-for="ticket in party.ticketsOwned"
                :key="ticket.id"
              >
                <v-expansion-panel-header class="px-4 py-2">
                  <div class="flex-grow-1">
                    <span
                      class="lh-1 text-overline"
                      style="font-size: 0.6rem !important"
                    >
                      #{{ ticket.id | shortId }}
                    </span>
                    <p class="lh-1 mb-0 font-weight-bold text-13">
                      {{ ticket.TicketBlock.TicketGroup.name }} •
                      {{ ticket.TicketBlock.name }}
                    </p>
                  </div>
                  <div class="flex-shrink-0 flex-grow-0">
                    <v-chip
                      x-small
                      :color="ticketStatus[ticket.Payment.status].color"
                    >
                      <v-icon
                        v-if="ticketStatus[ticket.Payment.status].icon"
                        x-small
                        left
                      >
                        {{ ticketStatus[ticket.Payment.status].icon }}
                      </v-icon>
                      {{ ticketStatus[ticket.Payment.status].text }}
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ticket-details-row
                    :ticketId="ticket.id"
                    :party="party"
                    :data="data"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <template v-if="party.ticketsTransfer.length > 0">
              <p class="mb-0 font-weight-bold mt-4">
                {{ party.ticketsTransfer.length }} Ingresso{{
                  party.ticketsTransfer.length > 1 ? "s" : ""
                }}
                Transferido{{ party.ticketsTransfer.length > 1 ? "s" : "" }}
              </p>
              <v-data-table
                :headers="headers"
                :items="party.ticketsTransfer"
                :items-per-page="party.ticketsTransfer.length"
                item-key="id"
                hide-default-footer
                dense
                single-expand
                show-expand
              >
                <template v-slot:item.id="{ item }">
                  <span class="text-overline lh-1">
                    #{{ item.id | shortId }}
                  </span>
                </template>
                <template v-slot:item.TicketBlock="{ item }">
                  <span class="text-truncate text-12 font-weight-bold lh-1">
                    {{ item.TicketBlock.TicketGroup?.name }}
                  </span>
                  <small class="d-block text-11 lh-1">
                    {{ item.TicketBlock.name }}
                  </small>
                </template>
                <template v-slot:item.transfer="{ item }">
                  {{ item.TicketTransfer.length }}
                </template>

                <template v-slot:item.buyer="{ item }">
                  <span class="text-truncate text-12 font-weight-bold">
                    {{ item.TicketTransfer[0].from.name || "Conta não criada" }}
                  </span>
                  <small class="d-block">
                    {{ item.TicketTransfer[0].from.phone }}
                  </small>
                </template>
                <template v-slot:item.owner="{ item }">
                  <span class="text-truncate text-12 font-weight-bold">
                    {{
                      item.TicketTransfer[item.TicketTransfer.length - 1].to
                        .name || "Conta não criada"
                    }}
                  </span>
                  <small class="d-block">
                    {{
                      item.TicketTransfer[item.TicketTransfer.length - 1].to
                        .phone
                    }}
                  </small>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="py-3">
                    <v-timeline align-top dense>
                      <v-timeline-item large>
                        <template v-slot:icon>
                          <v-tooltip slot="icon" v-if="!i" top>
                            <template v-slot:activator="{ on }">
                              <v-icon size="22" color="white" v-on="on">
                                mdi-account-cash
                              </v-icon>
                            </template>
                            <span>Comprador original</span>
                          </v-tooltip>
                        </template>
                        <div class="d-flex gap-3 align-center" style="flex: 3">
                          <baseAvatar
                            :size="30"
                            :src="item.TicketTransfer[0].from.photo"
                            :seed="item.TicketTransfer[0].from.id"
                          />
                          <div>
                            <span class="font-weight-bold">
                              {{
                                item.TicketTransfer[0].from.name ||
                                "Conta não criada"
                              }}
                            </span>
                            <small class="d-block">
                              {{ item.TicketTransfer[0].from.phone }}
                            </small>
                          </div>
                        </div>
                        <v-divider class="mt-4" />
                      </v-timeline-item>
                      <v-timeline-item
                        v-for="(transfer, i) in item.TicketTransfer"
                        :key="transfer.id"
                        class="pb-0"
                        :color="
                          i + 1 == item.TicketTransfer.length
                            ? 'success'
                            : 'primary'
                        "
                      >
                        <template v-slot:icon>
                          <span class="white--text font-weight-bold">{{
                            i + 1
                          }}</span>
                        </template>
                        <div class="d-flex gap-3" style="flex: 3">
                          <baseAvatar
                            class="mt-1"
                            :size="30"
                            :src="transfer.to.photo"
                            :seed="transfer.to.id"
                          />
                          <div class="flex-grow-1">
                            <span class="font-weight-bold">
                              {{ transfer.to.name || "Conta não criada" }}
                            </span>
                            <small class="d-block lh-1">
                              {{ transfer.to.phone }}
                            </small>
                          </div>
                          <small class="text-overline lh-1">
                            {{ transfer.createdAt | date("DD/MM/YY HH:mm") }}
                          </small>
                        </div>
                        <v-divider class="my-4" />
                      </v-timeline-item>
                    </v-timeline>
                  </td>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </div>
      </div>
    </v-card>
    <party-details-modal :data="data" />
    <ticket-transfer-modal :data="data" />
  </div>
</template>

<script>
import PAYMENT from "../../utils/payment";
import PartyDetailsModal from "./modal/PartyDetailsModal.vue";
import TicketTransferModal from "./modal/TicketTransferModal.vue";
import TicketDetailsRow from "./TicketDetailsRow.vue";

export default {
  components: { TicketDetailsRow, PartyDetailsModal, TicketTransferModal },
  data() {
    return {
      ticketStatus: PAYMENT.ticketStatus,
      showCancelled: false,
      search: "",
      headers: [
        {
          text: "ID",
          value: "id",
          sortable: false,
          width: 10,
          cellClass: "text-overline lh-1 px-1 text-12",
        },
        { text: "Lote", value: "TicketBlock", sortable: false },
        { text: "Transferencias", value: "transfer", align: "center" },
        { text: "Comprador", value: "buyer" },
        { text: "Proprietário Atual", value: "owner" },
        { text: "", value: "data-table-expand", cellClass: "px-1" },
      ],
    };
  },
  methods: {
    openParty(party) {
      this.$root.$emit("party-details", party);
    },
  },
  computed: {
    filteredEvents() {
      if (!this.search) return this.ticketsGroupedByParty;
      return this.ticketsGroupedByParty.filter((party) => {
        return party.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    ticketsGroupedByParty() {
      if (!this.data?.user?.TicketOwner) return [];
      var group = this.data.user.TicketOwner.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }).reduce((acc, ticket) => {
        const party = ticket.TicketBlock.TicketGroup.Party;
        if (!this.showCancelled && ticket.Payment.status === "canceled")
          return acc;
        if (!acc[party.id]) {
          acc[party.id] = {
            ...party,
            ticketsOwned: [],
            ticketsTransfer: [],
          };
        }
        acc[party.id].ticketsOwned.push(ticket);
        return acc;
      }, {});

      group = this.data.user.TicketTransfered.reduce((acc, ticket) => {
        const party = ticket.TicketBlock.TicketGroup.Party;
        if (!acc[party.id]) {
          acc[party.id] = {
            ...party,
            ticketsOwned: [],
            ticketsTransfer: [],
          };
        }
        acc[party.id].ticketsTransfer.push(ticket);
        return acc;
      }, group);

      return Object.values(group);
    },
  },
  props: {
    data: Object,
    loading: Boolean,
  },
};
</script>

<style></style>
